// ** UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const BODY_SM_DETAIL_SX = {
	lineHeight: '1.5625rem',
	letterSpacing: '-0.008px'
} as const;

const MetaRow = ({ label, value }: { label: string; value: string }) => (
	<Box>
		<Typography
			variant="body-sm"
			component="dt"
			sx={{
				color: 'text.secondary',
				fontWeight: 500,
				...BODY_SM_DETAIL_SX
			}}
		>
			{label}
		</Typography>
		<Typography
			variant="body-sm"
			component="dd"
			sx={{
				color: 'text.secondary',
				m: 0,
				...BODY_SM_DETAIL_SX
			}}
		>
			{value}
		</Typography>
	</Box>
);

export default MetaRow;
